import { FunctionComponent } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { FloorList } from "../../../modules/building/components/floor-list.component";
import { AllParams, ParamsNames } from "../../../modules/router/constantes/paramsNames";
import { RouteBuilder } from "../../../modules/router/constantes/routes.const";
import { EditIonBackButton } from "../../../modules/shared/components/edit-ion-back-button.component";
import { useEditRefresher } from "../../../modules/shared/hooks/use-edit-refresher.hook";
import { useBuilding } from "../../../modules/building/hooks/use-building.hook";
import { LoadingSiteListComponent } from '../../../modules/sites/components/loading-site-list.component';
import { useOrganizationCode } from "../../../modules/router/hooks/use-organization-code.hook";
import { useLocale } from "../../../modules/router/hooks/use-locale.hook";

export const BuildingPage: FunctionComponent = () => {
  const { t } = useTranslation();

  const params = useParams<Pick<AllParams, ParamsNames.SITE_ID | ParamsNames.BUILDING_ID>>();
  const location = useLocation<{ address?: string }>();
  const organizationCode = useOrganizationCode();
  const locale = useLocale();

  // Récupérer l'adresse depuis location.state ou sessionStorage (fallback pour Ionic)
  const buildingAddress = location.state?.address || sessionStorage.getItem('buildingAddress');

  const { building, fetchBuilding } = useBuilding(params.buildingId);

  const { ionRefresherRef, refreshCallback } = useEditRefresher(fetchBuilding);

  return (
    <IonPage>
      { building == null ? (<LoadingSiteListComponent message={ t('building.loadingMessage') }/>) : (
        <IonHeader role="header">
          <IonToolbar>
            <IonButtons slot="start">
              <EditIonBackButton defaultHref={ RouteBuilder.site(params.siteId, locale, organizationCode) }/>
            </IonButtons>
            { building && <IonTitle>{ building.name }</IonTitle> }
          </IonToolbar>
        </IonHeader>
      ) }
      { building == null ? null : (
        <IonContent>
          <IonRefresher ref={ ionRefresherRef } slot="fixed" onIonRefresh={ refreshCallback }>
            <IonRefresherContent/>
          </IonRefresher>
          { building && (
            <FloorList
              siteId={ params.siteId }
              buildingId={ params.buildingId }
              floorList={ building.floors }
              isExported={ building.isExported}
              floorListTitleLabel={ t('building.floorListTitle') }
              buildingAddress={ buildingAddress || undefined }
            />
          ) }
        </IonContent>
      ) }
    </IonPage>
  );
};
